module.exports = __webpack_public_path__ + "img/service-1-back.5d701300.png";